import gql from "graphql-tag"
const mutation = gql`
  mutation DeleteGroupCelebrationMutation($uuid: String!) {
    deleteGroupCelebration(uuid: $uuid)
  }
`
export default mutation
